export default __webpack_public_path__ + "static/media/spei_brand.4d627a67.png";